import { Navigate } from 'react-router-dom';
import { useGetCurrentUser } from 'apis/user/hook';
import Spinner from 'components/Common/Spinner';

type Props = { outlet: JSX.Element };

export default function AllowToAgencyUser({ outlet }: Props) {
  const { data: currentUser, isLoading: isCurrentUserLoading } = useGetCurrentUser();
  const isAgencyUser = Boolean(currentUser?.agency_user);

  if (isCurrentUserLoading) {
    return <Spinner />;
  }

  if (isAgencyUser) {
    return outlet;
  } else {
    return <Navigate to='/' state={window.location.href} />;
  }
}
